import { address as mezoMainnetAddress } from "@mezo-org/mezod-contracts/deployments/mainnet/mxSolvBTC.json"
import { address as mezoTestnetAddress } from "@mezo-org/mezod-contracts/deployments/testnet/mxSolvBTC.json"
import { Address } from "viem"

import artifacts from "#/shared/utils/artifacts"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0xd9D920AA40f578ab794426F5C90F6C731D159DEf",
  testnetAddress: "0x64d92C98793C4a55B9a88c2BB9E356650D0d83F5",
  mezoTestnetAddress: mezoTestnetAddress as Address,
  mezoMainnetAddress: mezoMainnetAddress as Address,
})
